import $http from '../../utils/http';
import $httpPost from '../modules/complaintApis/http'
import { parse } from 'qs';
let complaintPath = '/tio/integrity/api/';

// 获取地区
export const region = params => {
    return $http({
        url: complaintPath + 'dict/region',
        params
    });
};

// 获取当前用户身份
export const getUser = params => {
    return $http({
        url: complaintPath + 'auth/tioUserPermission',
        params
    });
};

// 各业态数据列表菜单标题
export const industryCategory = params => {
    return $http({
        url: complaintPath + 'dict/industryCategory',
        params
    });
};

// 涉旅企业统计
export const statisticsTotal = params => {
    return $http({
        url: complaintPath + 'statistics/total',
        params
    });
};

// 企业排行榜
export const enterpriseRanking = params => {
    return $http({
        url: complaintPath + 'statistics/enterprise/ranking',
        params
    });
};

// 州市诚信指数排行
export const citRanking = params => {
    return $http({
        url: complaintPath + 'statistics/city/ranking',
        params
    });
};

// 区县诚信指数排行
export const countyRanking = params => {
    return $http({
        url: complaintPath + 'statistics/county/ranking',
        params
    });
};

// 诚信指数
export const distribution = params => {
        return $http({
            url: complaintPath + 'statistics/score/distribution',
            params
        })
    }
    // 区县城市指数对比
export const countyCompare = params => {
    return $http({
        url: complaintPath + 'statistics/country/compare',
        params
    });
};

// 细分指数得分分部
export const exponentDistribution = params => {
    return $http({
        url: complaintPath + 'statistics/exponent/distribution',
        params
    });
};

// 细分指数得分分部
export const average = params => {
    return $http({
        url: complaintPath + 'statistics/exponent/average',
        params
    });
};

// 新增扣分
export const dictType = params => {
    return $http({
        url: complaintPath + 'dict/type',
        params
    });
};

// 诚信首页的展示

// 已完成任务
export const finisheList = params => {
    return $http({
        url: complaintPath + 'task/finished/list',
        params
    });
};
// 系统公告
export const taskNotice = params => {
    return $http({
        url: complaintPath + 'task/notice',
        params
    });
};
// 任务列表
export const taskPage = params => {
    return $http({
        url: complaintPath + 'task/page',
        params
    });
};
// 任务进度
export const taskProgress = params => {
    return $http({
        url: complaintPath + 'task/progress',
        params
    });
};
// 待办任务
export const todoList = params => {
    return $http({
        url: complaintPath + 'task/todo/list',
        params
    });
};
// 待办任务统计
export const todoTotal = params => {
    return $http({
        url: complaintPath + 'task/todo/total',
        params
    });
};

// 涉旅企业列表
export const getEnterpriseList = params => {
    return $http({
        url: complaintPath + 'statistics/getEnterpriseList',
        params
    });
};
// 待办任务详情
export const taskDetails = params => {
    return $http({
        url: complaintPath + 'task/details',
        params
    });
};

// 评分对象列表
export const workOrderPage = params => {
        return $http({
            url: complaintPath + 'ratingTask/workOrder/page',
            params
        });
    }
    // 任务信息
export const taskInfo = params => {
        return $http({
            url: complaintPath + 'grade/task/info',
            params
        });
    }
    // 评分任务详情
export const ratingTaskInfo = params => {
        return $http({
            url: complaintPath + 'ratingTask/info',
            params
        });
    }
    // 审核评分任务通过
export const auditPass = data => {
    return $http({
        url: complaintPath + 'ratingTask/audit/pass',
        data,
        method: 'POST'
    });
}

// 审核评分任务不通过
export const auditRejected = data => {
        return $http({
            url: complaintPath + 'ratingTask/audit/rejected',
            data,
            method: 'POST'
        });
    }
    // 企业详情
export const enterpriseDetail = data => {
    return $http({
        url: complaintPath + 'enterprise/getEnterpriseDetail',
        data,
        method: 'POST'
    });
}

// 审核评分操作记录
export const ratingTaskLog = params => {
        return $http({
            url: complaintPath + 'ratingTask/log',
            params
        });
    }
    // 品质指数
export const enterpriseHisQualityNormalList = data => {
    return $http({
        url: complaintPath + 'enterprise/getEnterpriseHisQualityNormalList',
        data,
        method: 'POST'
    });
}

// 规范指数
export const deductList = data => {
        return $http({
            url: complaintPath + 'standardScore/deductList',
            data,
            method: 'POST'
        });
    }
    // 待办详情'我知道了'
export const taskKnow = data => {
    return $http({
        url: complaintPath + 'task/know',
        data,
        method: 'POST'
    });
}

// 重点关注详情 黑名单详情
export const supervisionTaskInfo = params => {
    return $http({
        url: complaintPath + 'supervisionTask/info',
        params,
        method: 'GET'
    });
}

// 纳入黑名单
export const enterBlackList = data => {
        return $http({
            url: complaintPath + 'supervisionTask/enterBlackList',
            data,
            method: 'POST'
        });
    }
    // 工单详情
export const workOrderDetail = params => {
    return $http({
        url: complaintPath + 'taskShow/getWorkOrderDetail',
        params
    });
}

// 新增扣分进入页面获取对应列表数据
export const newDeduct = data => {
    return $http({
        url: complaintPath + 'standardScore/normalList',
        data,
        method: 'POST'
    })
}

// 新增扣分提交接口
export const create = data => {
    return $http({
        url: complaintPath + 'standardScore/create',
        data,
        method: 'POST'
    })
}

// 工单评分细则列表
export const workOrderScoringDetail = data => {
    return $http({
        url: complaintPath + 'taskShow/getWorkOrderScoringDetail',
        data,
        method: 'POST'
    });
}

// 工单评分细则列表
export const getScoringItems = data => {
    return $http({
        url: complaintPath + 'qualityScore/getScoringItems',
        data,
        method: 'POST'
    });
}

// 工单操作记录
export const workOrderLog = data => {
    return $http({
        url: complaintPath + 'workOrder/getWorkOrderLog',
        data,
        method: 'POST'
    });
}

// 下线扣分
export const cancel = data => {
    return $http({
        url: complaintPath + 'standardScore/cancel',
        data,
        method: 'POST'
    })
}

// 获取企业监管记录
export const getSupervisionLog = params => {
    return $http({
        url: complaintPath + 'supervisionTask/getSupervisionLog',
        params
    });
}

// 跳转至黑名单之前
export const checkBlacklist = data => {
    return $http({
        url: complaintPath + 'supervisionTask/tio/checkBlacklist',
        data,
        method: 'POST'
    });
}

// 跳转至重点关注之前
export const checkSupervision = data => {
    return $http({
        url: complaintPath + 'supervisionTask/tio/checkSupervision',
        data,
        method: 'POST'
    });
}

// (普通)退出重点关注
export const exitSupervision = data => {
    return $http({
        url: complaintPath + 'supervisionTask/exitSupervision',
        data,
        method: 'POST'
    });
}

// (管理员)退出重点关注
export const exitSupervisionByAdmin = data => {
    return $http({
        url: complaintPath + 'supervisionTask/exitSupervisionByAdmin',
        data,
        method: 'POST'
    });
}

// 新增整改资料
export const addRectifyLog = data => {
    return $http({
        url: complaintPath + 'supervisionTask/addRectifyLog',
        data,
        method: 'POST'
    });
}

// 企业规范指数扣分详情
export const deductDetail = data => {
    return $http({
        url: complaintPath + 'standardScore/deductDetail',
        data,
        method: 'POST'
    })
}

// 附件预览(图拍)
export const attach = data => {
    return $http({
        url: complaintPath + 'attach/getAttach',
        data,
        method: 'POST'
    })
}

// 评分任务进度统计
export const gradeProgress = params => {
    return $http({
        url: complaintPath + 'grade/task/progress',
        params
    })
}

// 企业详情
export const scarnDetails = params => {
    return $http({
        url: complaintPath + 'external/tio/enterprise/details',
        params
    })
}

// 登入人是否有企业数据权限
export const scarnEnterprise = params => {
    return $http({
        url: complaintPath + 'external/tio/user/auth/enterprise',
        params,
        method: 'POST'
    })
}

// 游客评价
export const evaluatePage = params => {
    return $http({
        url: complaintPath + 'external/tio/score/evaluate/page',
        params,
        method: 'GET'
    })
}

// 4.1首页代办 - 退出重点关注待审核
export const supervisionExit = params => {
    return $http({
        url: complaintPath + 'tio/todo/supervision/exit/details',
        params,
        method: 'GET'
    })
}

// 4.1 首页代办 - 退出重点关注审核不通过
export const supervisionNoPass = params => {
    return $http({
        url: complaintPath + 'tio/todo/supervision/audit/noPass/details',
        params,
        method: 'GET'
    })
}

// 4.1 首页代办 - 重点关注企业待评分
export const supervisionToScore = params => {
    return $http({
        url: complaintPath + 'tio/todo/supervision/toScore/details',
        params,
        method: 'GET'
    })
}

// 4.1 首页代办 - 黑名单预警企业待评分
export const supervisionWarning = params => {
    return $http({
        url: complaintPath + 'tio/todo/supervision/warning/details',
        params,
        method: 'GET'
    })
}

// 4.1 首页代办 - 受委托方选择
export const gradeList = params => {
    return $http({
        url: complaintPath + 'tio/grade/unit/list',
        params,
        method: 'GET'
    })
}

// 4.1 首页代办 - 评分标准选择
export const gradeNormalList = params => {
    return $http({
        url: complaintPath + 'tio/grade/quality/normal/list',
        params,
        method: 'GET'
    })
}

// 4.1、申请单列表
export const notePageList = params => {
        return $http({
            url: complaintPath + 'tio/note/page',
            params,
            method: 'GET'
        })
    }
    // 4.4 评分发布
export const taskDistribution = data => {
    return $http({
        url: complaintPath + 'tio/grade/task/distribution',
        data,
        method: 'POST'
    })
}

// 4.1、退出重点关注审核通过
export const supervisionAuditPass = data => {
    return $http({
        url: complaintPath + 'tio/todo/supervision/audit/pass',
        data,
        method: 'POST'
    })
}

// 4.1、退出重点关注审核不通过
export const supervisionAuditRejected = data => {
    return $http({
        url: complaintPath + 'tio/todo/supervision/audit/rejected',
        data,
        method: 'POST'
    })
}

// 21 22 待办详情
 const taskDetails2 = params => {
    return $http({
        url: complaintPath + 'task/details',
        params,
        method: 'GET'
    })
}

// 审核通过
const pass = data => {
    return $httpPost({
        url: complaintPath + 'bizAudit/pass',
        data,
        method: 'POST'
    })
}

const rejected = data => {
    return $httpPost({
        url: complaintPath + 'bizAudit/rejected',
        data,
        method: 'POST'
    })
}

const summary = params => {
    return $http({
        url: complaintPath + 'external/datav/evaluation/plan/summary',
        params,
        method: 'GET'
    })
}

const thirdEvaluate = params => {
    return $http({
        url: complaintPath + 'experience/third/evaluate/list',
        params,
        method: 'GET'
    })
}

const evaluationCount = params => {
    return $http({
        url: complaintPath +  'evaluationCount/list',
        params,
        method: 'GET'
    })
}

export default {
    getUser,
    industryCategory,
    region,
    statisticsTotal,
    enterpriseRanking,
    citRanking,
    countyRanking,
    distribution,
    countyCompare,
    exponentDistribution,
    average,
    finisheList,
    taskNotice,
    taskPage,
    taskProgress,
    todoList,
    todoTotal,
    dictType,
    getEnterpriseList,
    taskDetails,
    workOrderPage,
    taskInfo,
    ratingTaskInfo,
    auditPass,
    auditRejected,
    ratingTaskLog,
    enterpriseDetail,
    enterpriseHisQualityNormalList,
    deductList,
    newDeduct,
    create,
    taskKnow,
    supervisionTaskInfo,
    enterBlackList,
    workOrderDetail,
    workOrderScoringDetail,
    workOrderLog,
    cancel,
    getSupervisionLog,
    getScoringItems,
    checkBlacklist,
    checkSupervision,
    exitSupervision,
    exitSupervisionByAdmin,
    addRectifyLog,
    deductDetail,
    attach,
    gradeProgress,
    scarnDetails,
    scarnEnterprise,
    evaluatePage,
    supervisionExit,
    supervisionNoPass,
    notePageList,
    supervisionToScore,
    supervisionWarning,
    gradeList,
    gradeNormalList,
    taskDistribution,
    supervisionAuditPass,
    supervisionAuditRejected,
    taskDetails2,
    pass,
    rejected,
    summary,
    thirdEvaluate,
    evaluationCount
}